import React from "react";
import { checkoutUrl, floatingThumb, pricing } from "../data/landing";
type FloatingCtaProps = {
  onCheckout: () => void;
};
export function FloatingCta({
  onCheckout
}: FloatingCtaProps) {
  return <div className="flo" data-id="element-46" data-mp="3tvm5vlvtn50j">
      <div className="flow" data-id="element-47" data-mp="3tx73xlhch635">
        <a className="floa" href={checkoutUrl} onClick={onCheckout} data-id="element-48" data-mp="3ty8oqho5x6y2">
          <span className="flothumb" data-id="element-49" data-mp="3oyvqz1vr6fgp">
            <img src={floatingThumb.src} alt={floatingThumb.alt} data-id="element-50" data-mp="qfp5g4ngpbfe" />
          </span>
          <span className="floinfo" data-id="element-51" data-mp="qhrrkdlhukeu">
            <b className="flotit" data-id="element-52" data-mp="lg2hp1a0ccsc">Equilíbrio 60+ · 600 fichas + 4 bônus</b>
            <span className="floprices" data-id="element-53" data-mp="gpvun5v590c7">
              <i className="flonow" data-id="element-54" data-mp="gou6q0t14jd2">{pricing.price}</i>
              <s className="floold" data-id="element-55" data-mp="gnj6gaysltqp">{pricing.originalPrice}</s>
            </span>
            <span className="flotag" data-id="element-56" data-mp="boomv6t0415j">
              <b data-id="element-57" data-mp="196oo6o4d5p08">✦ Economize {pricing.savings}</b>
              <i data-id="element-58" data-mp="197hlyzlch468">Acesso imediato no seu e-mail</i>
            </span>
          </span>
          <span className="flobtn" data-id="element-59" data-mp="14eojyjh9g9xu">Garantir minha coleção agora</span>
        </a>
      </div>
    </div>;
}